import { appLanguageSwitch } from "./AppLanguageSwitch.slice";

export const appLanguageSwitchActions = { ...appLanguageSwitch.actions };
